export default __webpack_public_path__ + "static/media/1.67ab32c5.jpg";